import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Singapore: Country = {
    identifier: "Singapore",
    name: "Singapore",
    countryCode: "SG",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇸🇬",
    svgPath: "m 766.68475,459.2094 -0.42,0.185 -0.476,-0.168 0.154,-0.273 0.316,-0.066 0.256,0.087 0.145,0.066 0.1,0.075 z",
}
